
const ActionNames = 
{
    Breakthrough: "Breakthrough",
    CulturalHeritage: "Cultural Heritage",
    EfficientUpgrade: "Efficient Upgrade",
    EndowmentForTheArts: "Endowment for the Arts",
    EngineeringGenius: "Engineering Genius",
    Frugality: "Frugality",
    MilitaryBuildup: "Military Buildup",
    Patriotism: "Patriotism",
    Reserves: "Reserves",
    RevolutionaryIdea: "Revolutionary Idea",
    RichLand: "Rich Land",
    Stockpile: "Stockpile",
    UrbanGrowth: "Urban Growth",
}

module.exports = ActionNames;